<script setup>
  import { ref, computed, onMounted, onBeforeUnmount, defineProps, watch } from 'vue';
  
  let props = defineProps({
        theme: {
            type: String,
            default: "dark"
        }
    })

    const siteKey= computed(()=>{
        return import.meta.env.VITE_RECAPTCHA_SITE_KEY;
    })

//   const emit = defineEmits(['recaptcha-success', 'recaptcha-expired']);
  
  // References for reCAPTCHA token and widget ID
  const recaptchaCheckbox = ref(null);
  const recaptchaToken = defineModel();
  const recaptchaWidgetId = ref(null);
  
  function initializeRecaptcha() {
    // Render the reCAPTCHA widget and set up callbacks
    recaptchaWidgetId.value = grecaptcha.render(recaptchaCheckbox.value, {
        theme: props.theme,
      sitekey: siteKey.value,
      callback: onRecaptchaSuccess,
      'expired-callback': onRecaptchaExpired,
    });
  }
  
  function onRecaptchaSuccess(token) {
    recaptchaToken.value = token;
  }
  
  function onRecaptchaExpired() {
    recaptchaToken.value = null;
  }
  
  function resetRecaptcha() {
    if (recaptchaWidgetId.value !== null) {
      grecaptcha.reset(recaptchaWidgetId.value);
    }
  }

  let observer;
  onMounted(() => {
      let observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach(() => {
            let recaptchas = document.querySelectorAll('body > div[style*="z-index: 2000000000"]:not(.recaptcha-challenge)');
            if(recaptchas?.length > 0){
              for(recaptcha of recaptchas){
                recaptcha?.classList.add('recaptcha-challenge');
              }
              observer.disconnect()
            };
          });
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });

    // Set up the global callback to initialize reCAPTCHA
    window.onloadCallback = initializeRecaptcha;
  
    // Load the reCAPTCHA API if it hasn't been loaded yet
    if (typeof grecaptcha === 'undefined') {
      const script = document.createElement('script');
      script.src = 'https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit';
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    } else {
      initializeRecaptcha();
    }
  });
  
  onBeforeUnmount(() => {
    // Cleanup the global callback when the component is destroyed
    window.onloadCallback = undefined;
    observer?.disconnect();
  });


  watch(recaptchaToken, (newValue, oldValue) => {
    if (newValue == null, oldValue != null) {
      resetRecaptcha();
    }
  });
  </script>
  <template>
    <!-- reCAPTCHA checkbox will render here -->
    <div ref="recaptchaCheckbox"></div>
  </template>
  